module.exports = __webpack_public_path__ + "media/Teck_Copper_Hospital_Installation_Poster.635d0c8c.mp4";